module.exports = __webpack_public_path__ + "static/media/expressplaces.c84d7062.webp";